import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '#/renderer/router';
import moment from 'moment';
import 'moment/locale/es';

// Components
import CartSummary from '~/containers/Cart/CartSummary/CartSummary';
import Notification from '~/containers/Views/Notification/Notification.ui';
import CheckoutSteps from '~/containers/Checkout/CheckoutSteps';
import { textChars, emailChars, passwordChars } from '~/helpers/char-restriction';
import { useConfigMC } from '~/store/Query/api';
import { PATHNAME } from '~/store/States/global';

const CheckoutInfo = ({ registerForm, handleChange, handleSubmit }) => {
  const { data } = useConfigMC();
  const month = [];
  const days = [];
  const year = [];
  for (let i = 0; i < 12; i += 1) {
    const dateText = moment(i).locale('es');
    const monthText = dateText.month(i).format('MMMM');
    const monthNumber = dateText.month(i).format('MM');
    month.push(<option key={monthText} value={monthNumber}>{monthText}</option>);
  }

  const daysInMonth = 31;
  for (let i = 1; i <= daysInMonth; i += 1) {
    const dayText = moment(1).date(i).format('DD');
    days.push(<option key={dayText} value={dayText}>{dayText}</option>);
  }

  for (let i = 1917; i <= 2017; i += 1) {
    year.push(<option key={i} value={i}>{i}</option>);
  }

  return (
    <form name="registerCheckout" onSubmit={handleSubmit}>
      <h2>Registro de cuenta</h2>
      <h3 dangerouslySetInnerHTML={{ __html: data?.body.sesion?.registro }} />
      <p>Nombre</p>
      <label htmlFor="first_name">
        <input
          id="first_name"
          name="first_name"
          type="text"
          maxLength={30}
          placeholder="Nombre(s)"
          onKeyPress={textChars}
          value={registerForm.first_name}
          onChange={(e) => {
            handleChange(e, 'internalData.firstName');
          }}
        />
      </label>
      <p>Apellido</p>
      <label htmlFor="last_name">
        <input
          id="last_name"
          name="last_name"
          type="text"
          maxLength={30}
          placeholder="Apellido(s)"
          onKeyPress={textChars}
          value={registerForm.last_name}
          onChange={(e) => {
            handleChange(e, 'internalData.lastName');
          }}
        />
      </label>
      <p>Correo electrónico:</p>
      <label htmlFor="email_1">
        <input
          id="email_1"
          name="email_1"
          type="text"
          maxLength={40}
          placeholder="nombre@claro.com"
          onKeyPress={emailChars}
          value={registerForm.email_1}
          onChange={(e) => {
            handleChange(e, 'internalData.email');
          }}
        />
      </label>
      <p>Ingresa contraseña</p>
      <label htmlFor="registerPass">
        <input
          id="registerPass"
          name="registerPass"
          type="password"
          minLength={6}
          maxLength={12}
          onKeyPress={passwordChars}
          value={registerForm.password}
          onChange={(e) => {
            handleChange(e, 'internalData.password');
          }}
        />
      </label>
      <p>Confirma tu contraseña</p>
      <label htmlFor="registerPassConfirm">
        <input
          id="registerPassConfirm"
          name="registerPassConfirm"
          type="password"
          minLength={6}
          maxLength={12}
          onKeyPress={passwordChars}
          value={registerForm.passwordConfirm}
          onChange={(e) => {
            handleChange(e, 'internalData.passwordConfirm');
          }}
        />
      </label>
      <aside className="checkout--passreq">
        <div>Personalizar tu contraseña</div>
        <span>Recuerda que debe tener:</span>
        <ul>
          <li>Entre 6 y 12 caracteres</li>
          <li>Al menos una letra y un número</li>
          <li>Sin espacios en blanco, ni caracteres especiales</li>
        </ul>
      </aside>
      <b>* Campos obligatorios</b>
      <div className="checkout--info-comply">
        <label>
          <input type="checkbox" id="registerCompliance" name="registerCompliance" />
          <span>Al continuar estarás aceptando los </span>
        </label>
        <a href={`${PATHNAME}/terms`} target="_blank" rel="noopener noreferrer">
          Términos y Condiciones
        </a>
      </div>
      <aside className="checkout--continue">
        <Link to="/cart">
          <span>Regresar</span>
        </Link>
        <button type="submit">
          <span>Continuar</span>
        </button>
      </aside>
    </form>
  );
};

// for presentation purposes
// const CheckoutInfo = ({ goStep2 }) => (
//   <form>
//     <h2>Datos Personales</h2>
//     <p>Nombre</p>
//     <label>
//       <span>John Doe</span>
//     </label>
//     <p>Número de teléfono:</p>
//     <label>
//       <span>5544332211</span>
//     </label>
//     <p>Correo electrónico:</p>
//     <label>
//       <span>johndoe@email.com</span>
//     </label>
//     <p>DPI</p>
//     <label>
//       <span>2050555590101</span>
//     </label>
//     <aside className="checkout--continue">
//       <Link to="/cart"><span>Regresar</span></Link>
//       <button onClick={(e) => { goStep2(e); }}><span>Continuar</span></button>
//     </aside>
//   </form>
// );

const RegisterUI = ({ registerForm, handleChange, handleSubmit, renderStep2, error }) => (
  <main className="checkout">
    <CheckoutSteps active={1} />
    <section className="checkout--content">
      <section className="checkout--info">
        <CheckoutInfo
          registerForm={registerForm}
          handleChange={handleChange}
          handleSubmit={handleSubmit}
          goStep2={renderStep2}
        />
        {(error) ? <Notification title={error} /> : null}
      </section>
      <CartSummary />
    </section>
  </main>
);

RegisterUI.propTypes = {
  registerForm: PropTypes.shape({}).isRequired,
  handleChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  renderStep2: PropTypes.func.isRequired,
  error: PropTypes.string,
};

RegisterUI.defaultProps = {
  error: '',
};

CheckoutInfo.propTypes = {
  registerForm: PropTypes.shape({}).isRequired,
  handleChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
};

// UI.defaultProps = {};

export default RegisterUI;
